import { YANADOO_BLOCKED_IP } from 'common/config'

let ipCheckPromise = null // API 호출 중복 방지를 위한 Promise 캐싱

// IP 체크 함수
export const checkIpAddress = async () => {
  const excludedIp = localStorage.getItem('Excluded_IP')

  // 캐시된 IP 상태가 있으면 사용
  if (excludedIp) {
    return {
      isBlocked: excludedIp === 'Y',
      excludedIp
    }
  }

  // 이미 진행 중인 API 호출이 있다면 해당 Promise 반환
  if (ipCheckPromise) {
    return ipCheckPromise
  }

  // 새로운 API 호출 Promise 생성
  ipCheckPromise = (async () => {
    try {
      const response = await fetch('https://api.ipify.org/?format=json')
      if (!response.ok) throw new Error('Failed to fetch IP')

      const data = await response.json()
      const isBlocked = YANADOO_BLOCKED_IP.includes(data.ip)
      const newExcludedIp = isBlocked ? 'Y' : 'N'

      // 결과 캐싱
      localStorage.setItem('Excluded_IP', newExcludedIp)

      return {
        isBlocked,
        excludedIp: newExcludedIp
      }
    } catch (error) {
      console.error('IP check failed:', error)
      // IP 체크 실패 시 기본값 설정
      localStorage.setItem('Excluded_IP', 'N')
      return {
        isBlocked: false,
        excludedIp: 'N'
      }
    } finally {
      // API 호출 완료 후 Promise 캐시 초기화
      ipCheckPromise = null
    }
  })()

  return ipCheckPromise
}
